import PSprite from './PSprite';
import ObjectPool from './ObjectPool';
import DataModel from './DataModel';
import AudioConst from './AudioConst';

export default class AudioSteps extends PSprite {
    constructor() {
        super();
        this._interval = 0;
        this._selected = 0;
        this.onChange = null;
        this.canvas = new PIXI.Graphics();
        this.addChild(this.canvas);
        this.pool = new ObjectPool();

        this.interactive = true;
        this.on('click', (e) => this.onClick(e));

        this._range = new DataModel({
            min : 0,
            max : Infinity,
        });
        this._range.on("min", this.dirty, this);
        this._range.on("max", this.dirty, this);
    }

    get range(){
        return this._range;
    }

    setData(data) {
        this._data = data;
        this.dirty();
    }

    set selected(index) {
        this._selected = index;
        this.dirty();
    }

    getTotalWidth() {
        let p = 0;
        if(this._data) {
            let len = this._data.length;
            while(--len > -1) {
                let step = this._data[len];
                p += step.duration*this._interval;
            }
        }
        return p;
    }

    getSelectedPosition() {
        let p = 0;
        if(this._data) {
            let len = this._selected;
            while(--len > -1) {
                let step = this._data[len];
                p += step.duration*this._interval;
            }
        }
        return p;
    }

    onClick(e) {
        if(this._data) {
            let p = e.data.getLocalPosition(this.canvas);
            let len = this._data.length;
            let total = 0;
            for(let i=0; i < len; ++i) {
                let w = this._data[i].duration*this._interval;
                if(p.x >= total && p.x < total+w) {
                    if(this.onChange) {
                        this.onChange(i);
                    }
                    break;
                }
                total += w;
            }
        }
    }

    redraw() {
        this.clear();
        if(this._data) {
            let total = 0;
            let len = this._data.length;
            for(let index=0; index < len; ++index) {
                let w = this._data[index].duration*this._interval;
                const min = this.range.min;
                const max = this.range.max;
                if(w > 0 && total+w > min && total < max) { //只绘制范围内
                    const fillColor = 0xF2F2F2;
                    let borderColor;
                    let left, right, top, bottom
                    left = 1;
                    right = 1;
                    top = 1;
                    bottom = 1;
                    if(index == this._selected) {
                        borderColor = 0xF55658;
                    }else {
                        borderColor = 0x979797;
                    }
                    this.canvas.beginFill(borderColor);
                    this.canvas.drawRect(total, 0, w, AudioConst.AUDIO_STEP_H);
                    this.canvas.endFill();
                    this.canvas.beginFill(fillColor);
                    this.canvas.drawRect(total+left, top, w-left-right, AudioConst.AUDIO_STEP_H-top-bottom);
                    this.canvas.endFill();

                    let tf = this.getTF((index + 1).toString());
                    tf.x = total+w/2;
                    tf.y = AudioConst.AUDIO_STEP_H/2;
                    this.addChild(tf);
                }
                total += w;
            }
        }
    }

    clear() {
        this.canvas.clear();
        let len = this.children.length;
        while(--len > 0) { //第0个元素是canvas
            let tf = this.getChildAt(len);
            this.removeChild(tf);
            this.pool.push("tf", tf);
        }
    }

    set interval(value) {
        this._interval = value;
        this.dirty();
    }

    getTF(text) {
        let tf = this.pool.pop("tf");
        if(!tf) {
            tf = new PIXI.Text(text.toString(), {fontFamily: 'Arial', fontSize: 12, fill: 0xaaaaaa, align: 'center'});
            tf.label = "tf";
            const scale = 0.9;
            tf.scale = {x:scale, y:scale};
            tf.anchor.x = 0.5;
            tf.anchor.y = 0.5;
        }else {
            tf.text = text.toString();
        }
        return tf;
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioSteps.js